import { Input, MP4, UrlSource, CanvasSink } from 'mediabunny';

export async function getFrameAsPng(url: string, time: number): Promise<Blob> {
  const input = new Input({
    formats: [MP4],
    source: new UrlSource(url) // range requests only — no full download
  });

  try {
    const videoTrack = await input.getPrimaryVideoTrack();
    if (!videoTrack) {
      throw new Error('No video track found');
    }
    const firstFrameTimeStamp = await videoTrack.getFirstTimestamp();

    if (!(await videoTrack.canDecode())) {
      throw new Error('Video codec not decodable in this environment');
    }

    const finalTimestamp = Math.max(time, firstFrameTimeStamp); // firstFrame might start at non-zero time

    const sink = new CanvasSink(videoTrack);
    const result = await sink.getCanvas(finalTimestamp);
    if (!result) {
      throw new Error('Could not get canvas at the given time');
    }

    const { canvas } = result;

    if (canvas instanceof OffscreenCanvas) {
      return canvas.convertToBlob({ type: 'image/png' });
    }

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => (blob ? resolve(blob) : reject(new Error('toBlob returned null'))), 'image/png');
    });
  } finally {
    input[Symbol.dispose]();
  }
}
